import { useEffect } from 'react';

import { useSetTeamsConfigActions } from '../../store/main';
import { type TeamsPreviewPanelConfig } from '../../types';

export const useSetTeamsPreviewPanelConfig = (
	teamsPreviewPanelConfig: TeamsPreviewPanelConfig,
): void => {
	const { setTeamsPreviewPanelConfig } = useSetTeamsConfigActions();

	useEffect(() => {
		setTeamsPreviewPanelConfig(teamsPreviewPanelConfig);
	}, [setTeamsPreviewPanelConfig, teamsPreviewPanelConfig]);
};
